import { proxy, useSnapshot } from 'valtio';

type ScanPrelabelState = {
  show: boolean;
  prelabelScanId?: string;
};

const scanPrelabelState = proxy<ScanPrelabelState>({
  show: false,
  prelabelScanId: undefined,
});

export const toggleScanPrelabelVisibility = (): void => {
  scanPrelabelState.show = !scanPrelabelState.show;
};

export const setPrelabelScanId = (id: string | undefined): void => {
  scanPrelabelState.prelabelScanId = id;
};

export const resetScanPrelabelState = (): void => {
  scanPrelabelState.show = false;
  scanPrelabelState.prelabelScanId = undefined;
};

export const useScanPrelabelState = () => useSnapshot(scanPrelabelState);
